import {validateField, clearFields, setFieldOptions, setCheckBoxValue} from './helpers/form'
import {
  SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VACANCY_CRITERIA_ADAPTOR_FIELD,
  CLEAR_VACANCY_CRITERIA_ADAPTOR_FIELDS,
  SET_VACANCY_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/vacancy-page'

export function vacancyCriteriaAdaptor (
  state = {
    valid: false,
    fields: [
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Additional language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AgeFrom',
        value: '',
        errors: [],
        rules: {
          title: 'Age from'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'AgeTo',
        value: '',
        errors: [],
        rules: {
          title: 'Age to'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'Preferred  city'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'CountryofLiving',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Country of residence'
        },
        placeholder: 'Any country',
        options: []
      },
      {
        name: 'Region',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Region'
        },
        placeholder: 'Any region',
        options: []
      },
      {
        name: 'Ethnicity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Ethnicity'
        },
        placeholder: 'Any ethnicity',
        options: []
      },
      {
        name: 'Identity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Identity'
        },
        placeholder: 'Any identity',
        options: []
      },
      {
          name: 'DoNotUse',
          value: '',
          type: 'checkbox',
          errors: [],
          rules: {
            title: 'Do not use'
          },
          options: []
      },
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'SkillVendorStatus',
        value: '',
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Inactive talent'
        },
        options: []
      },/*end personal*/
      {
        name: 'AdaptorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'AdaptorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'AdaptorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video games'
        }
      },
      {
        name: 'AdaptorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promos/Commercials'
        }
      },
      {
        name: 'AdaptorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'AdaptorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'AdaptorAdaptorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Adaptor'
        }
      },
      {
        name: 'AdaptorDubbingDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing Director'
        }
      },
      {
        name: 'AdaptorTranslatorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Translator'
        }
      },
      {
        name: 'AdaptorVoiceActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Voice Actor'
        }
      },
      {
        name: 'AdaptorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'AdaptorNumberOfAdaptionsRange',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Number of adaptations'
        },
        placeholder: 'Any number',
        options: []
      },
      {
        name: 'AdaptorUniversityDegree',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'University degree'
        },
        placeholder: 'Any degree',
        options: []
      },
      {
        name: 'AdaptorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Adaptor'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'AdaptorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Adaptor'
        },
        placeholder: 'Any client'
      }
    ]
  },
  action
) {
  switch (action.type) {
    case SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'RemoteRecordingCapability', action.remoteRecordingCapabilityList);
      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VACANCY_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VACANCY_CRITERIA_ADAPTOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CRITERIA_ADAPTOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
